<template>
  <div id="app">
    <keep-alive :include="['BillIndex']">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
// import themeMixin from '@/common/mixins/theme'
export default {
  // mixins: [themeMixin]
}
</script>

<style lang="scss">
@import '@/styles/reset.scss';
@import '@/styles/global.scss';
@import '@/styles/theme.scss';
</style>
